<template>
    <v-container class="c-claims app-bg">
        <v-layout column >
            <p style="line-height:27px">
                <span style="font-size:16px; ">&nbsp;</span>
            </p>
            <p style="text-align:center;line-height:27px">
                <strong><span style="font-size:19px; ">关于防范保险从业人员违规销售非保险金融产品的风险提示</span></strong>            
            </p>
            <p style="line-height:27px">
                <span style="font-size:16px; ">&nbsp;</span>
            </p>
            <p style="text-indent:32px;line-height:27px">
                <span style="font-size:16px; ">近期，部分媒体报道了消费者遭遇保险从业人员违规销售非保险金融产品的情况。一些保险从业人员假借介绍保险产品名义，向消费者推销P2P等非保险金融产品，以“保本高收益”引诱消费者出资购买，有的甚至构成金融诈骗和非法集资。为此，中国银行保险监督管理委员会提醒广大金融消费者：</span>
            </p>
            <p style="text-indent:32px;line-height:27px">
                <strong><span style="font-size: 16px; ">一、核实资质，提高自我保护意识</span></strong>
            </p>
            <p style="text-indent:32px;line-height:27px">
                <span style="font-size:16px; ">原保监会发布的《中国保监会关于严格规范非保险金融产品销售的通知》（以下简称《通知》）中要求，保险公司、保险专业中介机构及其从业人员不得销售非经相关金融监管部门审批的非保险金融产品。同时，销售人员销售非保险金融产品前必须符合相应的资质要求。若有保险销售人员向您推荐非保险金融产品，请提高警惕，查验相关资质。</span>
            </p>
            <p style="text-indent:32px;line-height:27px">
                <strong><span style="font-size:16px; ">二、细读合同，确认产品属性</span></strong>
            </p>
            <p style="text-indent:32px;line-height:27px">
                <span style="font-size:16px; ">消费者在签署合同时，一定要认真阅读保险合同内容，确认保险产品的细则条款和重要信息（如保险责任、缴费方式、承保公司等），防止以假乱真。投保后，您可以通过拨打保险公司统一客服电话、登录官方网站或者前往保险公司柜面等方式，查验保单真伪。</span>
            </p>
            <p style="text-indent:32px;line-height:27px">
                <strong><span style="font-size:16px; ">三、理性消费，不受“保本高收益”迷惑</span></strong>
            </p>
            <p style="text-indent:32px;line-height:27px">
                <span style="font-size:16px; ">《通知》中规定：保险公司、保险专业中介机构销售非保险金融产品，应当向客户进行充分的信息披露和风险提示，不得采取违背客户意愿搭售产品的方式销售非保险金融产品，不得向客户销售超出其需求和风险承受能力的非保险金融产品。消费者在购买金融产品时，应当了解投资风险与投资收益成正比，不要盲目相信推销人员“保本高收益”的承诺，根据自己的实际需求和风险承受能力，通过正规销售渠道购买金融产品。</span>
            </p>
            <p style="line-height:27px;text-align:right">
                <span style="font-size:16px; ">文章来源：国家金融监督管理总局网站</span>
            </p>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: "1008"
    }
</script>

<style scoped>

</style>
